module.exports = __webpack_public_path__ + "img/mhz.abcca434.png";